import React from 'react';

import { Link } from 'react-router-dom';

function DeclarationFAQs() {
  const faqs = [
    {
      q: "1. Is this 'pay to play'?",
      a: "No. Declaration is awarded solely based on documented conformance to published standards. Payment of application fees covers the administrative cost of the review process but does not influence the outcome. If an applicant cannot demonstrate conformance, declaration is denied regardless of fee payment."
    },
    {
      q: "2. Is AASC a government regulator?",
      a: "No. The AI Accountability Standards Council is an independent, non-governmental standards body. We publish voluntary technical frameworks. Declaration does not constitute regulatory approval or compliance with laws like the EU AI Act."
    },
    {
      q: "3. Does declaration guarantee safety?",
      a: "No declaration can guarantee 100% safety or error-free operations. AASC accountability declaration serves as a baseline guard rail, confirming that the agency has established specific preventive controls, accountability structures, and oversight protocols at the time of assessment."
    },
    {
      q: "4. Who decides if an agency is declared?",
      a: "Declaration decisions are made by Council reviewers who assess the evidence submitted by the applicant against the specific requirements of the standard. The process is objective and evidence-based."
    },
    {
      q: "5. Can declaration be withdrawn?",
      a: "Yes. The Council maintains an active enforcement policy. Declaration may be withdrawn for material misrepresentation, misuse of the mark, or failure to maintain conformance. Withdrawn status is publicly visible in the registry."
    },
    {
      q: "6. Why should clients trust this?",
      a: "Trust is built on verification. AASC provides a public, immutable registry where clients can confirm an agency's status. The standards require concrete evidence (logs, policy documents) rather than just self-attestation, adding a layer of rigor to the claims."
    },
    {
      q: "7. How is this different from ISO or regulatory compliance?",
      a: "AASC standards are designed specifically for the agile, fast-moving context of organizations using AI. They focus on practical operational controls (like 'human-in-the-loop' triggers) rather than broad enterprise management systems (ISO) or legal mandates (Regulation)."
    },
    {
      q: "8. What if an agency claims declaration falsely?",
      a: "The Public Registry is the sole source of truth. If an agency claims declaration but does not appear in the registry with an 'Active' status, the claim is invalid. We encourage stakeholders to report misuse to the Council."
    },
    {
      q: "9. Can an agency be partially declared?",
      a: "Yes. Declaration has a defined scope. A large holding company might declare only its 'AI Automation Unit.' This scope must be clearly declared in the registry and in all client communications."
    },
    {
      q: "10. How often must agencies renew?",
      a: "Declaration is valid for 12 months. Organizations must renew annually by submitting updated documentation to demonstrate their continued adherence to the standards."
    }
  ];

  return (
    <>

      <div className="bg-[#F9FAFB] min-h-screen">
        {/* Header Section */}
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-6 py-16 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-[#102A43] mb-6">AASC Accountability Declaration FAQs</h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Clear answers regarding the declaration process, its limitations, and its value to the ecosystem.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-6 py-12">
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="p-6">
                  <h2 className="text-lg font-bold text-[#102A43] mb-3">{faq.q}</h2>
                  <p className="text-[#64748B] leading-relaxed text-sm md:text-base">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
             <p className="text-gray-600 mb-4">Still have questions?</p>
             <div className="flex justify-center gap-4">
               <Link to="/what-aasc-declaration-means-for-clients" className="text-[#2F80ED] hover:underline font-medium">
                 Read Client Guide
               </Link>
               <span className="text-gray-300">|</span>
               <a href="mailto:contact@aiaccountabilitycouncil.com" className="text-[#2F80ED] hover:underline font-medium">
                 Contact Us
               </a>
             </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeclarationFAQs;